import React from "react";
import Filter from '../../../components/CRM/Filter';
import ReferenceInput from "../../../components/CRM/ReferenceInput";
import ReferenceArrayInput from "../../../components/CRM/ReferenceArrayInput";
import TextInput from "../../../components/CRM/TextInput";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import NullableBooleanInput from "../../../components/CRM/NullableBooleanInput";
import DateInput from "../../../components/CRM/DateInput";
import SelectArrayInput from "../../../components/CRM/SelectArrayInput";

const PromoFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.promos.search" source="name_like" />
    <DateInput label="resources.promos.fields.validFrom" source="valid_from" />
    <DateInput label="resources.promos.fields.validTo" source="valid_to" />

    <ReferenceArrayInput
      label="resources.promos.fields.industry"
      source="industry_id"
      reference="industries"
      sort={{field: "name", order: "ASC"}}
      allowEmpty={false}
    >
      <SelectArrayInput optionText="name" />
    </ReferenceArrayInput>

    <ReferenceInput
      label="resources.promos.fields.marketingPartner"
      source="marketing_partner_id"
      reference="marketing_partners"
      sort={{field: "name", order: "ASC"}}
      allowEmpty={false}
    >
      <AutocompleteInput
        optionText={record => `${record.name}`}
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>

    <NullableBooleanInput source="active" defaultValue={true} />
  </Filter>
);

export default PromoFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/PromoFilter.js